import type { Locale } from "@/lib/i18n";
import { pl, type WPrezentationCardsTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const wPrezentationCardsTranslations: Record<Locale, WPrezentationCardsTranslations> = {
  pl,
  en,
  de,
};

export type { WPrezentationCardsTranslations };
